import { render, staticRenderFns } from "./VentasTotales.vue?vue&type=template&id=693e4865&scoped=true&"
import script from "./VentasTotales.vue?vue&type=script&lang=js&"
export * from "./VentasTotales.vue?vue&type=script&lang=js&"
import style0 from "./VentasTotales.vue?vue&type=style&index=0&id=693e4865&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693e4865",
  null
  
)

export default component.exports